import {httpRequest} from "../../../utils/HttpRequest";
import {
    IKey,
    IMdCmFields,
    IPage,
    ISearchPageField
} from "../../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import { appHttpRequest } from "@/utils/AppHttpRequest";

export interface IMdBeFields extends IMdCmFields {
    code?: string;
    name?: string;
    corporation?: string;
    phone?: string;
    address?: string;
    bank?: string;
    bankAccount?: string;
    note?: string;
}

export type IMdBeDetail = IKey & IMdCmFields & IMdBeFields;
export type IMdBeSearch = IMdBeFields & ISearchPageField;

class BeService {
    async insert(insertVo: IMdBeFields) {
        const apiUrl = "/be/insert";
        return await httpRequest.post<IMdBeDetail>(apiUrl, insertVo);
    }

    async update(updateVo: IMdBeFields) {
        const apiUrl = "/be/update";
        return await httpRequest.post<IMdBeDetail>(apiUrl, updateVo);
    }

    async disable(oneVo: IMdBeFields) {
        oneVo.sourceApp = "fms";
        const apiUrl = "/be/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo);
    }

    async find(searchVo: IMdBeFields) {
        const apiUrl = "/be/find";
        return await httpRequest.post<IMdBeDetail[]>(apiUrl, searchVo);
    }

    async beDs(searchVo: IMdBeFields) {
        let {retData} = await this.find(searchVo);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }

    async page(searchVo: IMdBeSearch) {
        const apiUrl = "/be/page";
        return await httpRequest.post<IPage<IMdBeDetail>>(apiUrl, searchVo);
    }

    async one(oneVo: IMdBeFields) {
        const apiUrl = "/be/one";
        return await httpRequest.post<IMdBeDetail>(apiUrl, oneVo);
    }

    async sync(syncVo: IMdBeFields) {
        const appPageUrl = "/be/sync";
        syncVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, syncVo,{ timeout: LONG_REQUEST_TIMEOUT });
    }

    async syncPage(searchVo: IMdBeSearch) {
        const appPageUrl = "/be/syncPage";
        searchVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdBeFields) {
        const appPageUrl = "/be/syncPage";
        oneVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }

        async mdPage(searchVo: IMdBeSearch) {
        const apiUrl = "/md/be/page";
        return await appHttpRequest.post<IPage<IMdBeDetail>>(apiUrl, searchVo);
    }
}

export const beService = new BeService();
